import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { EventCategoryRepository }  from 'Domain/Repositories';
import { message }              from 'antd';

export const deleteEventCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteEventCategoryRequest.type),
    mergeMap(action => from(EventCategoryRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Event Kategorie wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteEventCategorySuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteEventCategoryFailure(error),
          ]);
        })
      )
    ),
  );
};
